<template>
  <div class="full-screen-overlay-item">
    <slot name="default" v-if="render"></slot>
    <!-- <slot name="default" :index="index" v-if="render"></slot> -->
  </div>
</template>

<script lang="ts" setup>
import { injectionKey } from "./FullScreenOverlay.vue";

const props = defineProps({
  index: {
    type: Number as PropType<number>,
    required: true,
  },
});

const { visibleIndexRange } = inject(injectionKey)!;

const { index } = toRefs(props);

const render = computed(() => {
  return (
    visibleIndexRange.value[0] <= index.value &&
    index.value <= visibleIndexRange.value[1]
  );
});
</script>

<style scoped lang="postcss">
.full-screen-overlay-item {
  @apply relative snap-center w-screen h-screen shrink-0;
}
</style>
